<template>
  <div>
    <img v-if="status" class="picture-img" :src="img" alt="" />
    <!-- style="border:1px solid #999" -->
    <img  class="picture-img"  v-else src="../assets/images/none-img.png" alt="">
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: "",
    };
  },
  props: {
    img: String,
  },
  methods: {
    // 判断图片是否404
    isImgUrl(imgurl) {
      return new Promise(function (resolve, reject) {
        var ImgObj = new Image(); //判断图片是否存在
        ImgObj.src = imgurl;
        ImgObj.onload = function (res) {
          resolve(1);
        };
        ImgObj.onerror = function (err) {
          reject(0);
        };
      });
    },
  },
  mounted() {
    this.isImgUrl(this.img)
      .then((res) => {
        this.status = res;
      })
      .catch((res) => {
        this.status = res;
      });
  },
};
</script>
<style lang="less" scoped>
.picture-img {
  width: auto;
  height: 88px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/r-img-none.vue